import { render, staticRenderFns } from "./verified.vue?vue&type=template&id=cc501838&"
import script from "./verified.vue?vue&type=script&lang=js&"
export * from "./verified.vue?vue&type=script&lang=js&"
import style0 from "./verified.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports